import React from "react";
import ambulanceImg from "../assets/img/ambulance.jpg"; 

function Banner() {
  const callNumber = () => {
    const phoneNumber = "+917439213152";
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <section className="banner">
      <img className="container-back-img" src={ambulanceImg} alt="Ambulance" />
      <div className="container">
        <div className="banner-contain">
          <h1 className="fade-out fade-in ">Book 24/7 Emergency Ambulance Services</h1>
          <h6 className="fade-out fade-in ">
            Call on{" "}
            <button className="btn-null" onClick={callNumber}>
              +91 7439213152
            </button>{" "}
            to get confirmation in 1 minute
          </h6>
          <div className="row">
            {[
              "Fast & dependable",
              "Certified Professionals",
              "Fully equipped ambulances",
              "Clear & fair pricing",
              "Round-the-clock service",
              "Clean & disinfected vehicles",
            ].map((text, index) => (
              <div key={index} className="col4 flex-center">
                <button className="btn-null fade-out fade-in fade-out-right">
                  <i className="fa-solid flex-center fa-check"></i> {text}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
